export default ({...props}) => {
  const {size} = props.theme
  // COUNTRY CODE WIDTH TO BE REFINED
  return `
    .phonenumber-atom{
      & .country-code {
        max-width:${size(8.5)}px;
        width:auto;
      }
      gap:${size(2.5)}px;
      & .phone-number { 
        flex-grow: 1;
      }
   }
   .country-code,
   .phone-number{
        padding-left:0px;
   .MuiFormLabel-root
    {
     margin-left:${size(2)}px;
    }
  }
  .country-code{
      padding-right:0px;
  }
  `
}
